import request from '@/utils/request'

// 查询设计组件
export function getModuleParamsApi() {
  return request.get('/custom/getModuleParams')
}

// 查询纸张
export function getPaperSizeApi() {
  return request.get('/custom/getPaperSize')
}

// 保存及编辑保存
export function saveTemplateApi(data) {
  return request.post('/custom/saveTemplate/JiaBo', data)
}

// 查询模板
export function getTemplateApi() {
  return request.get('/custom/getTemplate/JiaBo')
}

// 获取模板(所有)
export function allJiaBoApi() {
  return request.get('/custom/getTemplate/allJiaBo')
}

// 打印
export function printApi(data) {
  return request.post('/custom/print/JiaBo', data)
}

// 预览
export function previewApi(data) {
  return request.post('/custom/print/preview', data)
}